import { Modal } from "antd";
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useGetGroups2 } from "../../api/api.get";
import { useGroupContext } from "../../providers/groups.provider";
import { capitalize } from "../../utils/functions";

export default function GroupDialog({
  open,
  onCancel,
  onOk,
}: {
  open: boolean;
  onCancel: () => void;
  onOk: () => void;
}) {
  const { data: groupsData } = useGetGroups2();
  const { changeDefaultGroupId, defaultGroupId } = useGroupContext();
  const [selectedGroupId, setSelectedGroupId] = useState<string | undefined>();

  useEffect(() => {
    if (defaultGroupId) {
      // check if this valid group id
      const groupRef = groupsData?.find((g) => g.id === defaultGroupId);
      if (groupRef) {
        setSelectedGroupId(defaultGroupId);
      } else {
        setSelectedGroupId(undefined);
      }
    }
  }, [defaultGroupId, groupsData]);

  const options = useMemo(() => {
    if (groupsData) {
      const _options = groupsData.map((g) => {
        return { label: capitalize(g.name), value: g.id };
      });
      return [{ label: "-- Select Group --", value: "" }, ..._options];
    }
  }, [groupsData]);

  const handleOk = async () => {
    console.log("handlok", selectedGroupId);
    if (selectedGroupId) {
      changeDefaultGroupId(selectedGroupId);
    } else {
      console.log("Please select group");
    }
    onOk();
  };

  return (
    <Modal
      title="Select Group"
      closable={{ "aria-label": "Custom Close Button" }}
      open={open}
      onOk={handleOk}
      okButtonProps={{ loading: false }}
      onCancel={onCancel}
    >
      <div className="flex flex items-center justify-between  mb-10">
        <div className="flex mt-4 gap-5">
          <select
            className="border rounded-lg px-4 py-2 min-w-xl"
            onChange={(e) => setSelectedGroupId(e.target.value)}
            value={selectedGroupId}
          >
            {options?.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </div>
        <Link to="/groups" className="text-blue-500 mt-4">
          Manage Groups
        </Link>
      </div>
    </Modal>
  );
}
